import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FileUploader } from 'ng2-file-upload';
import { HomeService } from '../home/home.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-provisoire',
  templateUrl: './provisoire.component.html',
  styleUrls: ['./provisoire.component.css']
})
export class ProvisoireComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  uploadForm2:FormGroup;
  displayedColumns = ['id', 'civilite','nom','adresse','codepostal','ville','tel1', 'tel2','mail','commentaire'];

  constructor(private _service:HomeService,private _formBuilder:FormBuilder) { }

  ngOnInit(): void {
    this.getPas= 0;
    this.nbrpa = 0;
    this.uploadForm2 = this._formBuilder.group({
      document: [null, null]
    });
    this.getFicheProvisoire();
  }


  public uploader2:FileUploader = new FileUploader({
    isHTML5: true
  });
  data2
  uploadSubmit2(){

    for (let i = 0; i < this.uploader2.queue.length; i++) {
      let fileItem = this.uploader2.queue[i]._file;
      if(fileItem.size > 90000000){
        alert("Taille du fichier doit être inférieure à  90 MB.");
        return;
      }
      console.log(this.uploader2.queue[i]._file)
    }
    for (let j = 0; j < this.uploader2.queue.length; j++) {
      let data = new FormData();
      let fileItem = this.uploader2.queue[j]._file;
      
      data.append('file', fileItem);
      data.append('fileSeq', 'seq'+j);
    //  data.append('id',this.id_file);
    
    // this.uploadFile(data).subscribe(data => alert(data.message));
    this._service.uploadProvesoir(data).subscribe(data=>{
       console.log(data)
     //  alert(data.message)
     this.data2= data;
     console.log(this.data2.status)
     if(this.data2.status =="fichier invalide !"){
      this.isOk2 =false;
      setTimeout(()=>{                           //<<<---using ()=> syntax
        this.isOk2 = null;
   }, 5000);
     }else{
      this.isOk2 =true;
      setTimeout(()=>{                           //<<<---using ()=> syntax
        this.getFicheProvisoire();
      }, 1000);
      setTimeout(()=>{                           //<<<---using ()=> syntax
        this.isOk2 = null;
   }, 5000);
     }
 
   },error=>{
    this.isOk2 =false;
    setTimeout(()=>{                           //<<<---using ()=> syntax
      this.isOk2 = null;
 }, 5000);
     })

    }
   
    this.uploader2.clearQueue();
    this.data = [];
    this.dataExel = null;

  }
  
  isOk2:boolean;
  listFiche
  listResult
  getPas:number;
  getFicheProvisoire(){
    this._service.getFicheprovisoir1(this.getPas).subscribe(
      data=>{
        this.listFiche= data;
        this.listResult = this.listFiche;
        this.listResult = new MatTableDataSource(this.listResult);
        console.log(data)
        this.telechargerProvisoir = this.listFiche.fichier;
        this.listResult.paginator = this.paginator;
        this.listResult.sort = this.sort;
      },error=>{
        alert("erreur")
      }
    )
  }
  
  suiv(){
    this.getPas ++;
    this._service.getFicheprovisoir1(this.getPas).subscribe(e=>{
      this.listFiche= e;
      this.listResult = this.listFiche;
      this.listResult = new MatTableDataSource(this.listResult);  
      this.listResult.paginator = this.paginator;
      this.listResult.sort = this.sort;

      console.log(this.listFiche)
    })
}
  pre(){
    console.log(this.getPas)
    if(this.getPas < 0){
      this.getPas = 0;
      return
    }
    this.getPas --;
    this._service.getFicheprovisoir1(this.getPas).subscribe(e=>{
      this.listFiche= e;
      this.listResult = this.listFiche;
      this.listResult = new MatTableDataSource(this.listResult);  
      this.listResult.paginator = this.paginator;
      this.listResult.sort = this.sort;

      console.log(this.listFiche)
    })  }
 expPro:boolean;
 telechargerProvisoir:string;

  exporterProvisoir(){
      if(this.telechargerProvisoir != ''){
        window.location.href = 'http://www.testback.kompar-energie.com'+this.telechargerProvisoir;
        this.expPro = true
      }else{
        this.expPro = false

      }
 
  }
  nbrpa:number;
  urlExport
  emptyExport
  dataExport
  testExport
  disabledExport = false;
  exporter(){
   this.testExport = "veuillez patienter"
    this._service.getFicheprovisoir(this.nbrpa).subscribe(e=>{
      console.log(e)
      this.dataExport = e;
      this.urlExport = this.dataExport.url
      this.emptyExport = this.dataExport.empty;
      console.log(this.urlExport)
     window.location.href = 'http://www.testback.kompar-energie.com/'+this.urlExport;
     this.nbrpa++;
     this.testExport = ""
     if(this.emptyExport ==true){
       this.disabledExport = true;
     }

    })
  }
    
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.listResult.filter = filterValue;

  }

  onFileChange(evt: any) {
    const target : DataTransfer =  <DataTransfer>(evt.target);
    
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;

      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      const wsname : string = wb.SheetNames[0];

      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      console.log(ws);

      this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));

      console.log(this.data);
      this.convertToArrayOfObjects(this.data);


    };

    reader.readAsBinaryString(target.files[0]);

  }
  data: [][];
   convertToArrayOfObjects(data) {
    var keys = data.shift(),
    
        i = 0, k = 0,
        obj = null,
        output = [];
       

    for (i = 0; i < data.length; i++) {
        obj = {};

        for (k = 0; k < keys.length; k++) {
            obj[keys[k]] = data[i][k];
        }

        output.push(obj);
    }
    
    console.log(output)
    this.dataExel = output;
    this.dataExel = JSON.parse(JSON.stringify(this.dataExel).replace(/\s(?=\w+":)/g, ""));
    this.dataExel = JSON.parse(JSON.stringify(this.dataExel).replace(/-/g, ""));

    console.log(this.dataExel)
    return output;
}
dataExel
effacer(){
  this.dataExel = null;
}
}
